'use client';

import { storyblokEditable } from '@storyblok/react/rsc';
import { FC, useState } from 'react';
import { BraFitterItemStoryblok } from 'storyblok-types';
import { Icon, IconType } from 'atoms/Icon';
import { Image } from 'atoms/Image/Image';
import { Input } from 'atoms/Input';
import { H4, P, Span } from 'atoms/Typography';
import { Tooltip } from 'molecules/Tooltip';
import { RichTextMarkdown } from '../RichText';
import styles from './styles.module.css';

export const BraFitterItem: FC<{ blok: BraFitterItemStoryblok }> = ({
  blok,
}) => {
  const { image, inputTitle, inputPlaceholder, textNearInput, tooltipText } =
    blok;
  const [openTooltip, setOpenTooltip] = useState(false);
  const [value, setValue] = useState('');

  return (
    <div className={styles.item} {...storyblokEditable(blok)}>
      {image?.filename && (
        <Image
          src={image.filename}
          alt={image?.alt}
          className={styles.itemImage}
        />
      )}
      <div className={styles.itemContent}>
        <div className={styles.inputTitleContent}>
          {inputTitle && <Span>{inputTitle}</Span>}

          <Tooltip
            open={openTooltip}
            onClose={() => setOpenTooltip(false)}
            element={
              <RichTextMarkdown
                text={tooltipText}
                components={{
                  h4: ({ children }) => (
                    <H4 className={styles.tooltipHedline}>{children}</H4>
                  ),
                  p: ({ children }) => (
                    <P className={styles.tooltipText}>{children}</P>
                  ),
                }}
              />
            }
          >
            <Icon
              type={IconType.info}
              onClick={() => setOpenTooltip(true)}
              className={styles.icon}
            />
          </Tooltip>
        </div>

        <div className={styles.inputContent}>
          <Input
            placeholder={inputPlaceholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            classes={{ input: styles.input }}
          />
          {textNearInput && (
            <Span className={styles.textNearInput}>{textNearInput}</Span>
          )}
        </div>
      </div>
    </div>
  );
};
